import getQueryVariable from "@/utils/getQueryVariable.js";
const Appid = "wx52c921c9addc8c22"
const redirect_uri = encodeURIComponent(`${window.location.origin}${window.location.pathname}?date=${getQueryVariable("date") ? getQueryVariable("date") : ""}`)
const Scope_url =
  `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${Appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`

export {
  Appid,
  Scope_url
}